import { createFileRoute } from '@tanstack/react-router';

import { ProduccionPage } from '@/features/produccion/components/produccion-page';
import { produccionSearchSchema } from '@/features/produccion/constants/search-params';

export const Route = createFileRoute('/_app/produccion/')({
  component: ProduccionPage,
  validateSearch: (raw) => produccionSearchSchema.parse(raw),
});
